import getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  list: [],
  listOptions: [],
  listByNetwork: [],
  listByNetworkOptions: [],
  listType: [],
  listTypeOptions: [],
  listTypeByNetwork: [],
  listTypeByNetworkOptions: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
